import { configureStore } from '@reduxjs/toolkit';
import { reducer } from './duck';

export const store = configureStore({
  reducer: {
    appContext: reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
